// 将 UTC(event.publishedAt) 时间转换为东9区时间
export function convertTimeZone(date: string | Date) {
  return new Date(
    (typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {
      timeZone: "Asia/Tokyo",
    })
  );
}
